module.exports = __webpack_public_path__ + "static/media/2-1-canada-preframed-poster.5a9be722.webp";